import { fetchMissingAssociatedIssues } from '../../command/associated-issues/index.tsx';

const mapDispatchToProps = {
	fetchMissingAssociatedIssues,
};

export default mapDispatchToProps;
